export const clientsTable = {
  header: 'Clients',

  name: 'Name',
  integration: 'Integration',
  company: 'Liable company',
  defaultRole: 'Default Role',
  defaultFeeStructure: 'Default Fee Structure',

  createClient: 'Create Client',

  search: 'Search Client Name',
};
export const companyTable = {
  header: 'Companies',

  id: 'Company ID',
  name: 'Display Name',
  status: 'Account Holder Status',
  merchantId: 'Google Pay Merchant ID',
  feeStructure: 'Fee Structure',

  empty: 'This client has no company assigned',
  createCompany: 'Create Company',
};
export const rowActions = {
  view: 'View Client Details',
  edit: 'Edit',
  delete: 'Delete',
};
export const clientDetails = {
  integration: clientsTable.integration,
  company: clientsTable.company,
  defaultRole: clientsTable.defaultRole,
  defaultFeeStructure: clientsTable.defaultFeeStructure,
  homepageUrl: 'Homepage URL',
  loginUrl: 'Login URL',
  tosUrl: 'Terms of Service URL',
  landingPageUrl: 'Product Landing Page URL structure ',
  disputeEmails: 'Dispute Emails',
  adminButtonColor: 'Admin Button Color',
  adminButtonText: 'Admin Button Text',
  adminButtonTextColor: 'Admin Button Text Color'
};
export const clientDetailsActions = {
  editClient: 'Edit Client',
  deleteClient: 'Delete Client',
  forceDeleteClient: 'Force Delete Client',
  buttonTitle: 'Actions',
  deleteClientModalHeader: (noOfCompanies) =>
    `This client is linked to ${noOfCompanies} companies. Are you sure you want to delete it?`,
  deleteClientModalCtaTitle: 'Yes',
  deleteClientModalCta2Title: 'No',
  forceDeleteClientModalHeader:
    'Are you sure you want to delete this client from the database?',
  deleteSuccess: 'You have successfully deleted the client.',
  deleteError: 'There was an error deleting the client.',
};
